export default __webpack_public_path__ + "static/media/lease-search-result.a74c788f.svg";